import { Bloc, delay } from "@kernel/frontend-react-app";
import {
  StatsRepositoryState,
  defaultStatsRepositoryState
} from "./StatsRepositoryState";
import { MainBloc } from "modules/main";
import {
  GetStatsFileInteractor,
  LoadStatsRepositoryInteractor,
  RemoveStatsFileInteractor
} from "./interactors";
import { StatsDownloadService } from "@domain";

export class StatsRepositoryBloc extends Bloc<StatsRepositoryState> {
  private mainBloc: MainBloc | null = null;
  private loadInteractor: LoadStatsRepositoryInteractor;
  private getStatsFileInteractor: GetStatsFileInteractor;
  private removeStatsFileInteractor: RemoveStatsFileInteractor;
  constructor() {
    super(defaultStatsRepositoryState);
    this.loadInteractor = LoadStatsRepositoryInteractor.create();
    this.getStatsFileInteractor = GetStatsFileInteractor.create();
    this.removeStatsFileInteractor = RemoveStatsFileInteractor.create();
  }

  public setMainBloc(mainBloc: MainBloc) {
    this.mainBloc = mainBloc;
  }

  public getMainBloc(): MainBloc {
    if (!this.mainBloc) {
      throw new Error("MainBloc not set");
    }
    return this.mainBloc;
  }

  public async load(room?: string): Promise<void> {
    this.getMainBloc().startLoading("Caricamento repository statistiche...");
    try {
      await delay(500);
      const index = await this.loadInteractor.execute({ room });
      this.changeState({
        ...this.state,
        index
      });
    } catch (err) {
      this.getMainBloc().handleError(err);
    } finally {
      this.getMainBloc().stopLoading();
    }
  }

  public async removeFile(name: string): Promise<void> {
    this.getMainBloc().startLoading("Rimozione file statistiche...");
    try {
      await delay(500);
      const index = await this.removeStatsFileInteractor.execute({ name });
      this.changeState({
        ...this.state,
        index
      });
    } catch (err) {
      this.getMainBloc().handleError(err);
    } finally {
      this.getMainBloc().stopLoading();
    }
  }

  public async download(name: string, type: "json" | "csv") {
    this.getMainBloc().startLoading("Scarico file statistiche...");
    try {
      await delay(500);
      const statsFile = await this.getStatsFileInteractor.execute({ name });
      if (type === "json") {
        StatsDownloadService.exportToJson(statsFile.stats.toDto(), name);
      } else {
        StatsDownloadService.exportToCsv(statsFile.stats.toDto(), name);
      }
    } catch (err) {
      console.error(err);
      this.getMainBloc().handleError(err);
    } finally {
      this.getMainBloc().stopLoading();
    }
  }

  public static create(): StatsRepositoryBloc {
    return new StatsRepositoryBloc();
  }
}
